let state = {
  data: null
};

let getters = {
  BannerList(state) {
    let list = [];
    state.data && state.data.goodsComponent && state.data.goodsComponent.forEach((item)=>{
      if(item.type === "carousel"){
        list = item.data;
      }
    })
    return list;
  },
  titlePrice(state){
    let obj = null;
    state.data && state.data.goodsComponent && state.data.goodsComponent.forEach((item)=>{
      if(item.type === "title_price"){
        obj = item.data;
      }
    })
    return obj;
  },
  goodsSpecification(state){
    let obj = null;
    state.data && state.data.goodsComponent && state.data.goodsComponent.forEach((item)=>{
      if(item.type === "goods_specification"){
        obj = item.data;
      }
    })
    return obj;
  },
  goodsInfo(){
    let obj = null;
    state.data && state.data.goodsComponent && state.data.goodsComponent.forEach((item)=>{
      if(item.type === "goods_info"){
        obj = item.data;
      }
    })
    return obj;
  },
  selectedSku(state,getters){
    return getters.goodsSpecification && getters.goodsSpecification.selectedSku;
  }
}

let mutations = {
  setData(state, data) {
    state.data = data;
  }
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations
};
